// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './icons' //图标
import {ActionSheet, Dialog, DatePicker, Toast} from 'cube-ui'
import store from './store'
// import fastClick from 'fastClick'
import VueLazyload from 'vue-lazyload'

import './assets/styles/common.sass'

// 解决300毫秒延时
// fastClick.attach(document.body)

Vue.use(ActionSheet)
Vue.use(Dialog)
Vue.use(DatePicker)
Vue.use(Toast)
Vue.use(VueLazyload)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js